import { gql } from "@apollo/client";

import { Viewer } from "src/generated/types";

export const PROMOTION_QUERY = gql`
    query PromotionData {
        viewer {
            user {
                id
                school {
                    id
                    currentReport {
                        id
                        percentCompleted
                        promotionProgress
                        status
                        submissionProgress
                        surveyUrls
                        surveysCompleted
                        constituentGroups
                    }
                    currentReports {
                        edges {
                            node {
                                id
                                type
                                promotionProgress
                                percentCompleted
                                status
                                submissionProgress
                                surveysCompleted
                                constituentGroups
                            }
                        }
                    }
                }
            }
        }
    }
`;

export interface ApolloQueryData {
    viewer: Viewer;
}
